module.exports = __webpack_public_path__ + "static/media/interface.083421bd.png";